
<template>
    <v-app id="app">
        <v-container v-if="isAuthenticated" class="vld-parent">
            <div id="title">
                <router-link to="/">
                    <img src="../src/assets/ic-enlace.png" />
                    Gestión de enlaces
                </router-link>
            </div>
            <div id="user">
                <span class="current-user">{{userName}}</span>
                <div>
                    <template v-if="sammAccountName == null">
                        <v-btn class="accountName"
                               small
                               :loading="loadingUser"
                               :disabled="loadingUser"
                               @click="obtenerSammAccountName">
                            ¿Mi account name de SM?
                        </v-btn>
                    </template>
                    <template v-else>
                        <span class="accountName-label current-user">Mi account name de SM es : {{sammAccountName}}</span>
                    </template>
                </div>
                <span class="logout">
                    <a href="#" v-on:click.stop="logOut()">
                        Log out
                        <span class="arrow-forward"></span>
                    </a>
                </span>
            </div>
            <!--<div id="nav">
                <router-link to="/admin">
                    <span>Administración</span>
                </router-link>
            </div>-->
            <div>
                <router-view />
                <vue-snotify></vue-snotify>
                <v-overlay :value="isLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-snackbar v-model="snackbar"
                            :timeout="timeout">
                    {{ textError }}
                </v-snackbar>
            </div>
        </v-container>
        <v-container v-else>
            <div id="login">
                <div class="container-login" v-on:click="logIn">
                    <i class="material-icons">person</i>
                    <div>LOGIN</div>
                </div>
            </div>
        </v-container>
    </v-app>
</template>


<script>
    import authentication from './authentication'
    import { eventHub } from './http-common/eventhub';
    // Import stylesheet

    export default {
        name: 'app',
        data() {
            return {
                isLoading: false,
                snackbar: false,
                textError: '',
                timeout: 2000,
                sammAccountName: null,
                loadingUser: false
            }
        },
        components: {
        },
        computed: {
            isAuthenticated() {
                return authentication.isAuthenticated();
            },
            userName() {
                return authentication.getUserProfile().name;
            }
        },
        methods: {
            logOut() {
                authentication.signOut();
            },
            logIn() {
                authentication.signIn();
            },
            showSpinner() {
                this.isLoading = true;
            },
            hideSpinner() {
                this.isLoading = false;
            },
            async obtenerSammAccountName() {
                try {
                    let user = await this.$store.dispatch('obtenerSammAccountName');
                    this.sammAccountName = user;
                } catch (ex) {
                    eventHub.$emit('error', ex)
                }
            },
            onError(error) {
                this.isLoading = false;
                this.snackbar = true;
                this.textError = error;
            }
        },
        created: function () {
            eventHub.$on("before-request", this.showSpinner);
            eventHub.$on("request-error", this.onError);
            eventHub.$on("after-response", this.hideSpinner);
            eventHub.$on("response-error", this.onError);
            eventHub.$on("error", this.onError);
        },
        beforeDestroy: function () {
            eventHub.$off("before-request", this.showSpinner);
            eventHub.$off("request-error", this.hideSpinner);
            eventHub.$off("after-response", this.hideSpinner);
            eventHub.$off("response-error", this.hideSpinner);
            eventHub.$off("error", this.hideSpinner);
        }
    }</script>

<style>
    #title a {
        cursor: pointer;
        color: #fff!important;
        text-decoration: none;
    }

    #nav a {
        float:right;
        cursor: pointer;
        color: #a3e0ff!important;
        text-decoration: none;
        transition: all .3s ease-out;
    }

    #nav a:hover {
        color: #fff!important;
        transition: all .3s ease-out;
    }

        #nav .material-icons {
            font-size: 40px;
            color: #a3e0ff;
            transition: all .3s ease-out;
        }

            #nav .material-icons:hover {
                color: #fff;
                transition: all .3s ease-out;
            }

    .v-expansion-panels {
        margin-bottom: 10px;
    }

        .v-expansion-panels .v-expansion-panel-header {
            color: #1976d2;
            padding-left: 34px;
        }

    #app {
        font-family: 'Montserrat', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #ffffff;
        padding: 50px;
        background-color: #375260;
    }

    #login {
        font-family: 'Montserrat', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #ffffff;
        padding: 50px;
        background-color: #375260;
        height: 100vh;
        cursor: pointer;
    }

    .container-login {
        border-radius: 50%;
        background-color: #a3e0ff;
        color: #375260;
        width: 400px;
        height: 400px;
        margin: 0 auto;
        margin-top: 10%;
    }

        .container-login .material-icons {
            font-size: 300px;
            display: block;
        }

    #title {
        font-size: 50px;
    }

        #title img {
            height: 50px;
        }

    #user {
        margin-bottom: 10px;
    }

        #user .current-user {
            float: left;
        }

        #user .logout {
            float: right;
            margin-right: 15px;
        }

            #user .logout a {
                text-decoration: none;
                color: #a3e0ff;
                transition: all .3s ease-out;
            }

                #user .logout a:hover {
                    color: #fff;
                }

            #user .logout:hover a,
            #user .logout:hover a .to-top {
                color: #fff;
            }

    .arrow-forward {
        float: right;
        margin-left: 15px;
        color: #a3e0ff;
        padding-top: 24px;
        display: inline-block; /* or block */
        position: relative;
        border-color: #a3e0ff;
        text-decoration: none;
        transition: all .3s ease-out;
        transform: rotate(90deg);
    }

        .arrow-forward:before {
            content: '▲';
            font-size: .9em;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -.7em;
            border: solid .13em #a3e0ff;
            border-radius: 10em;
            width: 1.4em;
            height: 1.4em;
            line-height: 1em;
            border-color: inherit;
            transition: transform .5s ease-in;
        }

    #user .logout:hover a .arrow-forward {
        color: #fff;
        border-color: #fff;
    }

        #user .logout:hover a .arrow-forward:before {
            transform: rotate(360deg);
        }

    .accountName {
        float: left;
        margin-top: -5px;
        margin-left: 14px;
    }

    .accountName-label {
        margin-left: 14px;
        text-decoration:double;
    }
</style>